import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(1),
    cursor: "pointer",
    width: "95%",
    padding: `0 ${theme.spacing(1)}`,
    display: "flex",
  },
  dialogContent: {
    padding: `0 !important`,

    "& .mat-content": {
      width: "100%",
    },
  },
  dialogHeader: {
    backgroundColor: "white !important",
  },
  dialogActions: {
    margin: "0 !important",
    padding: `0 ${theme.spacing(2.5)}  ${theme.spacing(2)} !important`,
  },
  changeButton: {
    color: theme.palette.events.bluePrimary,
  },
}));
